import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../api/mail.api';
import { toast } from 'react-toastify';

export const useSendMail = () => {
  const q = useQueryClient();
  return useMutation({
    mutationFn: api.sendMail,
    onSuccess: () => {
      toast.success('Message sent');
      q.invalidateQueries(['mail','messages']);
      q.invalidateQueries(['mail','unified']);
    },
    onError: () => {
      toast.error('Failed to send message');
    }
  });
};

export const useReply = () => {
  const q = useQueryClient();
  return useMutation({
    mutationFn: ({ mailboxId, payload }) => api.replyMail(mailboxId, payload),
    onSuccess: () => {
      toast.success('Reply sent');
      q.invalidateQueries(['mail','thread']);
      q.invalidateQueries(['mail','messages']);
    },
    onError: () => {
      toast.error('Failed to send reply');
    }
  });
};
